<template lang="pug">
el-collapse-item(name='uploadArquivos')
    template(slot='title')
        h2.collapse-titulo {{ $t('mensagens.territorio.arquivo.tituloProdutor') }}

    .collapse-conteudo
        UploadArquivosAr(
            @add='onAdd'
            @delete='onDelete'
            :items='items'
            :mostrar-titulo='false'
        )
</template>

<script>
import UploadArquivosAr from '@/components/territorio/UploadArquivosAr.vue';

export default {
    name: 'UploadArquivosCollapse',
    components: {
        UploadArquivosAr
    },
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        onAdd(value) {
            this.$emit('add', value);
        },
        onDelete(index) {
            this.$emit('delete', index);
        }
    }
};
</script>

<style lang="scss" scoped>
.collapse-titulo {
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    margin-left: 20px;
    color: #3b3b3b;
}

.collapse-conteudo {
    padding: 16px;
}
</style>
